import { useEffect, useState } from "react";
import { DownloadSimple, X } from "@phosphor-icons/react";

export default function InstallPWA() {
  const [prompt, setPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem("pwa-dismissed") === "1",
  );

  useEffect(() => {
    function handler(e) {
      e.preventDefault();
      setPrompt(e);
    }
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!prompt || dismissed) return null;

  async function install() {
    prompt.prompt();
    await prompt.userChoice;
    setPrompt(null);
  }

  return (
    <div
      data-testid="pwa-install"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-sm z-40 bg-white border border-[#E2E0D8] rounded-sm shadow-lg p-4 flex items-center gap-3"
    >
      <div className="w-10 h-10 rounded-sm bg-[#2A5A3B] flex items-center justify-center shrink-0">
        <DownloadSimple size={20} color="#fff" weight="bold" />
      </div>
      <div className="flex-1">
        <div className="text-sm font-bold">Instalar CEDUP Leite</div>
        <div className="text-xs text-[#4E544B]">
          Instale como um app no seu celular.
        </div>
      </div>
      <button
        data-testid="pwa-install-btn"
        onClick={install}
        className="text-sm font-bold text-white bg-[#2A5A3B] hover:bg-[#1E412A] px-3 py-2 rounded-sm"
      >
        Instalar
      </button>
      <button
        onClick={() => {
          localStorage.setItem("pwa-dismissed", "1");
          setDismissed(true);
        }}
        className="text-[#4E544B] p-1"
        aria-label="Fechar"
      >
        <X size={16} />
      </button>
    </div>
  );
}
